import * as actionTypes from "./actionTypes";

export const getChatPosts = (chatType: number) => ({
  type: actionTypes.GET_CHAT_POSTS,
  chatType
});

export const sendChatPost = (chatType: number, content: string) => ({
  type: actionTypes.SEND_CHAT_POST,
  chatType,
  content
});

export const deleteChatPosts = (postIds: number[]) => ({
  type: actionTypes.DELETE_CHAT_POSTS,
  postIds
});
